<ng-template #template let-row="row">
  <div
    class="subrow-notifications__remarks-and-validations flex"
    *ngIf="
      row?.validationMessages.length ||
      row.remarks ||
      doesLineSupportGrainPreSale(row.orderingInformation.allowedOrderTypes) ||
      (row.orderingInformation?.siloDistributionRequirements !== noSilosNeeded && !row?.silos?.length && !row.returnInformation)
    "
  >
    <mat-divider class="spacing--margin-horizontal"></mat-divider>

    <div
      class="subrow-notifications__remarks notification notification-blank text--input-small spacing--margin-half-top remarks"
      *ngIf="row.remarks && cartLineRemarksAvailable$ | async"
    >
      <div class="flex flex--nowrap flex--align-center">
        <mat-icon class="spacing--margin-right subrow-notifications__remarks-comments-icon"> comment </mat-icon>
        <div class="flex__child flex__child--auto">{{ row.remarks }}</div>
      </div>
    </div>

    <div
      class="subrow-notifications__info-wrapper"
      *ngIf="doesLineSupportGrainPreSale(row.orderingInformation.allowedOrderTypes) && isUserAtLeastAdvisor$ | async"
      [ngClass]="{ 'spacing--margin-top': !row.remarks }"
    >
      <div class="subrow-notifications__info notification notification-info text--input-small spacing--margin-none-top spacing--margin-none-bottom">
        <mat-icon class="flex--align-self-center"> info </mat-icon>
        <div>
          {{ 'cart.cart-subrow-notification-GrainPreSalesOrder' | translate }}
        </div>
      </div>
    </div>

    <div
      class="subrow-notifications__error-wrapper"
      *ngIf="row.validationMessages || (row.orderingInformation?.siloDistributionRequirements !== noSilosNeeded && !row?.silos?.length)"
      [ngClass]="{
        'spacing--margin-top': !row.remarks || (doesLineSupportGrainPreSale(row.orderingInformation.allowedOrderTypes) && (isUserAtLeastAdvisor$ | async)),
      }"
    >
      <div
        *ngFor="let message of row.validationMessages"
        class="subrow-notifications__error notification text--input-small spacing--margin-none-top"
        [class]="'notification-' + (message.severityLevel | lowercase)"
      >
        <mat-icon class="flex--align-self-center">
          {{ message.severityLevel | lowercase }}
        </mat-icon>
        <div>
          {{ message | formatValidationMessage }}
          <span *ngIf="message.severityLevel !== 'Warning'" class="subrow-notifications__validation-message-error-code">
            {{ 'cart-feedback.errorCode' | translate }} {{ message.errorCode }}</span
          >
        </div>
      </div>
    </div>
  </div>
</ng-template>
